import { GET, POST, PUT } from './api';

const table = 'tentativa-cobrancas';

// usuario, usuario_email, distribuidor e cliente sao preenchidos pelo servidor
// a partir do token e da cobranca: enviar esses campos no payload nao tem efeito.
export const Create = async (params) => {
  return await POST(`/${table}`, params, true);
};

export const Read = async (filters = '') => {
  return await GET(`/${table}${filters}`, true);
};

export const ReadOne = async (id) => {
  return await GET(`/${table}/${id}?populate=*`, true);
};

// So o autor da tentativa (ou um administrador) consegue alterar.
export const Update = async (params, id) => {
  return await PUT(`/${table}/${id}`, params, true);
};

export const ReadByCobranca = async (id, filters = '') => {
  return await GET(
    `/${table}?filters[cobranca][id][$eq]=${id}&sort=data:desc${filters}`,
    true
  );
};

export const ReadByTitulo = async (id, filters = '') => {
  return await GET(
    `/${table}?filters[titulo][id][$eq]=${id}&sort=data:desc${filters}`,
    true
  );
};

// Historico da pessoa: atravessa todos os contratos do cliente.
// A resposta ja vem com cliente e cobranca populados.
export const ReadByCliente = async (id, filters = '') => {
  return await GET(
    `/${table}?filters[cliente][id][$eq]=${id}&sort=data:desc${filters}`,
    true
  );
};

// Efetividade por numero discado, ordenado do pior para o melhor.
// Resposta: { total_tentativas, telefones: [...] }, onde improdutivo marca
// numero invalido ou 3+ tentativas sem nenhum contato efetivo.
// Alimentado pelo telefone_utilizado gravado em cada tentativa.
export const ResumoTelefones = async (params = {}) => {
  const query = new URLSearchParams(params).toString();
  return await GET(`/${table}/resumo-telefones?${query}`, true);
};

// Tentativas de todos os contratos do escopo do usuario num intervalo de
// `data` (datetime). `since` e `until` vao em ISO, ja convertidos do dia local
// pelo chamador. Alimenta o painel de desempenho dos operadores.
export const ReadByPeriod = async (since, until, page = 1) => {
  return await GET(
    `/${table}?filters[data][$gte]=${since}&filters[data][$lte]=${until}&sort=data:asc&pagination[page]=${page}&pagination[pageSize]=1000`,
    true
  );
};
